import React from 'react';
import { convertInAlternativeCurrency } from '../utils/convertInAlternativeCurrency';
import { getConfiguration } from '../utils/configuration';
import { getCurrencySymbol } from '../utils/getCurrencySymbol';
import { getPrintableAmount } from '../utils/getPrintableAmount';
import { getLabel } from '../../data/labels';

function Winnings(props) {
    const conf = getConfiguration();
    const currency = getCurrencySymbol(conf.cs.ct);
	const potWinAltCurr = convertInAlternativeCurrency(props.winnings && props.winnings > 0? props.winnings : props.potentialWinnings);
    return (
        <>
            {['paid', 'to_be_paid', 'winning', 'losing', 'winning_cashback'].includes(props.status) ?
                <>
                    {props.status !== 'losing' ?
                        <div className="winnings-box justify-content-center d-flex flex-column text-small won">
                            <span>{(props.status === 'winning_cashback'? getLabel('mybets.winning_cashback') : getLabel('mybets.vincita')) + (props.paidWithCashout? (' - ' + getLabel('cashout.button_text')) : '')}</span>
                            <span className="text-medium bold">
                            	{getPrintableAmount(props.winnings && props.winnings > 0? props.winnings : props.potentialWinnings, conf.cs.m, conf.cs.nd)} {currency}
                        		{potWinAltCurr && <span> / {potWinAltCurr} </span>}
                        	</span>
                        </div>
                        :	
                        <div className="winnings-box justify-content-center d-flex flex-column text-small lost">
                            <span>{getLabel('mybets.perdente')}</span>
                            <span className="text-medium bold">{getPrintableAmount(0, conf.cs.m, conf.cs.nd)} {currency}</span>
                        </div>
                    }
                </>
                :
                <div className="d-flex flex-column text-small">
                    <span className="grey">{getLabel('mybets.vincitapotenziale')}</span>
                    <span className="text-medium bold">
                    	{getPrintableAmount(props.potentialWinnings, conf.cs.m, conf.cs.nd)} {currency}
                		{potWinAltCurr && <span> / {potWinAltCurr} </span>}
                	</span>
                </div>
            }
        </>
    );
}

export default Winnings;